"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveSessionPlayerDisplayName = resolveSessionPlayerDisplayName;
/**
 * Human-facing label for a session player (`user_player_name` when set).
 * Falls back to character name, player slot name, user id, or player id.
 */
function resolveSessionPlayerDisplayName(sessionPlayer, options) {
    const { variableStore, gameSession, contextPlayer } = options;
    const userId = String(sessionPlayer.userId || '').trim();
    let display;
    if (userId && variableStore) {
        const cacheService = variableStore
            .cacheService;
        const sessionCache = cacheService?.cache?.get(gameSession.id);
        if (sessionCache?.userVariablesByUserId) {
            const userVars = sessionCache.userVariablesByUserId.get(userId);
            const userVar = userVars?.get('user_player_name');
            if (userVar?.value !== undefined && userVar?.value !== null) {
                display = String(userVar.value);
            }
        }
        if (display === undefined) {
            const userContext = {
                playerId: contextPlayer.id,
                characterName: contextPlayer.characterName,
                currentSceneId: contextPlayer.currentScene,
                userId
            };
            const value = variableStore.getVariable('user_player_name', userContext);
            if (value !== undefined && value !== null) {
                display = String(value);
            }
        }
    }
    if (!display) {
        display =
            (sessionPlayer.characterName && String(sessionPlayer.characterName).trim()) ||
                sessionPlayer.playerName ||
                undefined;
    }
    return (display && display.trim()) || userId || String(sessionPlayer.id);
}
//# sourceMappingURL=sessionPlayerDisplayName.js.map